import React, { useCallback, useEffect, useState } from 'react'
import { Box, Paper, TableContainer, Table, TableBody, TableCell, TableRow, Tooltip, IconButton, TableHead, Select, InputLabel, FormControl, MenuItem } from '@mui/material'
import ReactPaginate from 'react-paginate';
import { useGetAllSigPaginationMutation } from '../app/services/SIGGroupServices';
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from 'react-router-dom';
function EnhancedTableHead() {
  const headCells = [
    { id: "groupName", numeric: false, disablePadding: true, label: "Group Name" },
    { id: "description", numeric: false, disablePadding: true, label: "Description" },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ];

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

function SigPendingTable() {
  const [getAllSig] = useGetAllSigPaginationMutation();
  const [getAllSIGGroup, setGetAllSigGroup] = useState([]);
  const [page, setPage] = useState(0);
  let [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState("");
  // const rowsPerPage = '10'
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const handlePageChange = () => {
    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };
  const handlePageClick = ({ selected }) => {
    setSearchTerm('')
    setError("");
    setPage(selected);
  };

  //fetch data get pagination for sig
  const fetchData = useCallback(() => {
    getAllSig({ page: page + 1, itemsPerPage: rowsPerPage, approve: 0, })
      .unwrap()
      .then((res) => {
        if (res.status) {
          if (res.data.sigDetails.length === 0 && page >= 1) {
            setPage(page - 1);
          }
          setGetAllSigGroup(res?.data.sigDetails || []);
          setTotalCount(res?.data.totalCount || 0);
        } else {
          setGetAllSigGroup([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching pending sig group:", error);
      });
  }, [page, rowsPerPage, getAllSig]);
  //calculate pagecount
  const pageCount = Math.ceil(totalCount / rowsPerPage);
  //handle page click


  // Fetch data on component mount and when dependencies change
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <>
      <Box>
        <>
          <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
              <EnhancedTableHead />
              <TableBody>
                {getAllSIGGroup.length > 0 ? (
                  getAllSIGGroup.map((row, index) => (
                    <TableRow
                      hover
                      key={index}
                      sx={{
                        cursor: "pointer",
                        backgroundColor:
                          index % 2 === 0 ? "#f0f0f0" : "white",
                      }}
                    >
                      <TableCell align="center">{row.groupName}</TableCell>
                      <TableCell
                        align="center"
                        style={{
                          width: 500,
                        }}
                      >
                        <span dangerouslySetInnerHTML={{ __html: row?.description?.slice(0, 100) }} />
                        {row?.description?.length > 100 && "..."}
                      </TableCell>

                      <TableCell align="center">
                        <Tooltip title="View">
                          <IconButton
                            onClick={() => { navigate('/admin/view-pending-sig/' + row?._id) }}
                          >
                            <VisibilityIcon className='icon-vieweye-color' />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      Will Be Added Shortly
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
        <div className="">
          {getAllSIGGroup.length > 0 && (
            //     <ReactPaginate
            //         pageCount={pageCount} // Replace with the total number of pages
            //         pageRangeDisplayed={rowsPerPage}
            //         marginPagesDisplayed={2}
            //         onPageChange={handlePageClick}
            //         containerClassName={"pagination"}
            //         activeClassName={"active"}
            //         previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
            //         nextLabel={
            //             pageCount > 1 && page + 1 !== pageCount ? "Next" : null
            //         }
            //         forcePage={page}
            //         disabledClassName={"disablebtn"}
            //     />
            // ) : (
            //     <></>
            <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
              <div className="mb-2 mb-md-0">
                <div className="d-flex gap-2">
                  <input
                    type="number"
                    min={1}
                    placeholder="Page no."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  <div className="goPage cursor-pointer" onClick={handlePageChange}>
                    <h5 className="p-2 m-0">Go</h5>
                  </div>
                </div>
                {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
              </div>

              {/* Pagination in the Center */}
              <div className="my-3 my-md-0">
                <ReactPaginate
                  pageCount={pageCount} // Calculate total pages
                  pageRangeDisplayed={1}
                  marginPagesDisplayed={1}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page}
                  previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                  nextLabel={
                    pageCount > 1 && page + 1 !== pageCount ? "Next" : null
                  }
                  disabledClassName={"disablebtn"}
                />
              </div>
              <div className="mb-2 mb-md-0">
                <FormControl variant="outlined">
                  <InputLabel></InputLabel>
                  <Select
                    className="itemsperpage"
                    value={rowsPerPage}
                    onChange={(e) => {
                      const value = e.target.value;
                      setRowsPerPage(value);
                      setError('');
                      setSearchTerm('');
                      setPage(0);
                    }}
                    MenuProps={{
                      MenuListProps: {
                        sx: {
                          display: 'flex',
                          flexDirection: 'column',
                        },
                      },
                    }}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>

                </FormControl>
              </div>
            </div>
          )
          }
        </div>
      </Box>
    </>
  )
}

export default SigPendingTable